import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResearchSelectionService } from './research-selection.service';

/**
 * Attaches the active research id to every API request so scoped endpoints
 * (experiments, preprocessing, label mappings) filter server-side.
 */
export const researchInterceptor: HttpInterceptorFn = (req, next) => {
  const selection = inject(ResearchSelectionService);
  const id = selection.activeId();
  if (id && !req.headers.has('X-Research-Id')) {
    req = req.clone({ setHeaders: { 'X-Research-Id': id } });
  }
  return next(req);
};
